"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var fallback_1 = __importDefault(require("./fallback"));
var flattenFragment_1 = __importDefault(require("./flattenFragment"));
var childrenWithIndex = function (children, shouldAdd, _a) {
    if (shouldAdd === void 0) { shouldAdd = function (el) { return typeof el.type !== 'string'; }; }
    var _b = (_a === void 0 ? {} : _a).getIndex, getIndex = _b === void 0 ? function (el, idx) { return fallback_1.default(el.props.index, idx); } : _b;
    var flattened = flattenFragment_1.default(children);
    return react_1.Children.map(flattened, function (el, idx) {
        if (!react_1.isValidElement(el))
            return el;
        if (!shouldAdd(el))
            return el;
        var rEl = el;
        return react_1.cloneElement(rEl, {
            index: getIndex(rEl, idx),
        });
    });
};
exports.default = childrenWithIndex;
